import getAll from "api/event";

const getEvents = (start, end) => (dispatch) =>
  dispatch({
    type: "EVENTS_GET",
    payload: getAll(start, end),
  });

export default getEvents;
